/* import __COLOCATED_TEMPLATE__ from './push-disabled.hbs'; */
import { bool } from '@ember/object/computed';
import Component from '@ember/component';
import { closeModal } from 'sh-www/utils/modal-controls';

export default Component.extend({
  tagName: '',

  /**
   * True if this is an iOS context
   *
   * passed in from caller
   *
   * @type {boolean}
   */
  isIos: bool('model.isIos'),

  /**
   * True if this is an Android context
   *
   * passed in from caller
   *
   * @type {boolean}
   */
  isAndroid: bool('model.isAndroid'),

  actions: {
    closeModal() {
      closeModal(this);
    },
  }
});
